import { FileUploadErrorDTO } from '../project/project.type';

export interface FileUploadResponse {
  message: string;
  results: SingleFileUploadResponse[];
}

export interface SingleFileUploadResponse {
  fileName: string;
  projectId?: string;
  status: number;
  statusString: (typeof FileUploadResponseStatus)[keyof typeof FileUploadResponseStatus];
  errors: FileUploadErrorDTO[];
}

export const FileUploadResponseStatus = {
  Failed: 'Failed',
  Success: 'Success',
  Exists: 'Exists',
} as const;

export const FileUploadStatus = {
  Idle: 'Idle',
  Uploading: 'Uploading',
  Parsing: 'Parsing',
  Failed: 'Failed',
  Success: 'Success',
  SuccessWithWarning: 'SuccessWithWarning',
  Exists: 'Exists',
} as const;

export enum TypeOfFile {
  Project = 'Project',
  CostAnalysis = 'CostAnalysis',
  PayApp = 'PayApp',
}

export const projectFilesToAccept = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
};

export const costAnalysisFilesToAccept = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
  'application/vnd.ms-excel': ['.xls'],
};
